import * as Types from '../action-types';

let dataReducer = function(state = {}, action) {
    switch (action.type) {
        case Types.ENUM_REQUEST_SUCCESS:
            let result = {};
            result[action.enumType] = action.results;
            return Object.assign({}, state, result);
        default:
            return state;
    }
};

export default dataReducer;
